<template>
  <div>
    <h4>卡片管理</h4>
    <router-view></router-view>
  </div>
</template>
